import { render, staticRenderFns } from "./bac-resolution.vue?vue&type=template&id=503f282c&"
import script from "./bac-resolution.vue?vue&type=script&lang=js&"
export * from "./bac-resolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports